var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmallLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 36,
    viewBox: "0 0 136 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9046 17.9387L10.7213 26.9156L8.48726 30.7803L-0.000244141 25.8785L4.59472 17.9209L-0.000244141 9.96344L8.48979 5.07178L10.6224 8.75384L15.9021 17.9007C15.9017 17.9134 15.9025 17.9261 15.9046 17.9387Z",
    fill: "url(#paint0_linear_1403_4490)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1144 17.9234C43.1144 20.2767 42.6509 22.6069 41.7502 24.781C40.8496 26.9552 39.5295 28.9306 37.8654 30.5945C36.2012 32.2584 34.2256 33.5782 32.0514 34.4785C29.8771 35.3789 27.5468 35.8421 25.1935 35.8417H11.4999L12.9048 33.4175L16.6071 27.0018H25.1935C26.3987 27.0219 27.5957 26.8019 28.715 26.3547C29.8342 25.9074 30.8532 25.2418 31.7126 24.3967C32.5719 23.5516 33.2544 22.5439 33.7203 21.4323C34.1862 20.3207 34.4262 19.1274 34.4262 17.9221C34.4262 16.7169 34.1862 15.5236 33.7203 14.412C33.2544 13.3004 32.5719 12.2927 31.7126 11.4476C30.8532 10.6024 29.8342 9.93685 28.715 9.4896C27.5957 9.04235 26.3987 8.82238 25.1935 8.84252H16.5082L12.9048 2.60179L11.4036 0H25.1935C27.5471 -2.35633e-08 29.8777 0.463621 32.0521 1.36439C34.2266 2.26515 36.2023 3.58542 37.8664 5.2498C39.5305 6.91417 40.8505 8.89006 41.751 11.0646C42.6514 13.2392 43.1147 15.5698 43.1144 17.9234Z",
    fill: "url(#paint1_linear_1403_4490)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2439 10.4951H63.1989C68.1851 10.4951 71.3396 13.2736 71.3396 17.7067C71.3396 22.1398 68.2072 24.8341 63.1989 24.8341H57.2439V10.4951ZM63.1989 22.1752C66.3977 22.1752 68.4063 20.432 68.4063 17.6713C68.4063 14.9105 66.3756 13.1497 63.1989 13.1497H60.0002V22.1752H63.1989Z",
    fill: "#151515"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9812 10.4951H88.5946V13.1497H77.7419V16.1051H87.4045V18.7596H77.7419V22.1353L88.5946 22.1575V24.812H74.9812V10.4951Z",
    fill: "#151515"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0054 10.4951H106.619V13.1497H95.7661V16.1051H105.429V18.7596H95.7661V22.1353L106.619 22.1575V24.812H93.0054V10.4951Z",
    fill: "#151515"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M109.578 25.1748H119.352V27.8294H109.578V25.1748Z",
    fill: "#151515"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M126.497 17.5739L121.272 10.4951H124.909L128.24 15.0167L131.395 10.4951H135.036L129.917 17.2908L135.478 24.812H131.837L128.152 19.8037L124.666 24.812H121.029L126.497 17.5739Z",
    fill: "#151515"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1403_4490",
    x1: -0.000244141,
    y1: 17.9209,
    x2: 15.9046,
    y2: 17.9209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F85D31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1403_4490",
    x1: 11.4036,
    y1: 17.9209,
    x2: 43.1144,
    y2: 17.9209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0EB4E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B75C2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogo);
export default __webpack_public_path__ + "static/media/smallLogo.ffaf58a149010ab3935691b0ffdc8237.svg";
export { ForwardRef as ReactComponent };